var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MobileFilterModal',{attrs:{"filterStore":_vm.filterStore}},[_c('div',{attrs:{"slot":"contents"},slot:"contents"},[_c('CategoriesFilter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }